module.exports = __webpack_public_path__ + "static/media/venus-mars.6e87624f.svg";